import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import chatbotImage from '~chatbot/assets/chatbot-character.webp';
import { useChatbotContext } from '~chatbot/context/ChatbotContext';
import styles from './ChatbotIntroResponse.module.scss';

import SuggestedOptions from '~chatbot/ui/SuggestedOptions';
import RequestCallback from '../RequestCallback';

function ChatbotIntroResponse({
  response,
  showSuggestedOptions,
  showTiming,
  externalTimingClass,
  externalResponseClass,
  showRcbOption = false,
}) {
  const { getTimings, config } = useChatbotContext();
  const { productName } = config;

  return (
    <div className={styles.wrapper}>
      <img
        src={chatbotImage}
        alt="chatbot"
        className={styles.chatimage}
      />

      <div className={styles.message}>
        <div
          className={classNames(
            styles.response,
            { [externalResponseClass]: !!externalResponseClass },
          )}
        >
          <div>
            { response || (
              <>
                Hi, I'm&nbsp;
                <span role="img" aria-label="intro">
                  Aditi 👋🏻,
                  Scaler's AI Powered Admissions Counsellor
                </span>
                , and I am here to help you become an
                industry-ready software engineer at
                {' '}
                {productName}
                <br />
                How can I assist you today?
              </>
            )}
          </div>
          {showTiming && (
            <div
              className={classNames(
                { [externalTimingClass]: !!externalTimingClass },
              )}
            >
              {getTimings()}
            </div>
          )}
        </div>
        {
          showRcbOption && (
            <RequestCallback />
          )
        }
        {showSuggestedOptions && <SuggestedOptions />}
      </div>
    </div>
  );
}

ChatbotIntroResponse.defaultProps = {
  showSuggestedOptions: true,
  showTiming: true,
};

ChatbotIntroResponse.propTypes = {
  response: PropTypes.string,
  showSuggestedOptions: PropTypes.bool,
  showTiming: PropTypes.bool,
  externalTimingClass: PropTypes.string,
  externalResponseClass: PropTypes.string.isRequired,
};

export default ChatbotIntroResponse;
